module.exports = __webpack_public_path__ + "static/media/iq.8d936728.svg";